import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import { ReactComponent as Add } from 'src/assets/icons/oldPortal/adicionar.svg';
import { ReactComponent as End } from 'src/assets/icons/lineTrash.svg';
import { ReactComponent as Download } from 'src/assets/icons/download2.svg';
import { ReactComponent as View } from 'src/assets/icons/goBack.svg';
import showToast from '../toastyService';

import ExtensionIcon from '../ExtensionIcon';
import { isValid } from 'src/services/auth';
import { newTab } from 'src/pages/home';
import { RenderPdf } from '../renderPdf';

export function Anexos({
  Editavel,
  Config,
  OnChange,
  Anexos,
  RemoveAnexo,
  RemoveFile,
  GetFile,
  Files,
  DefaultData,
}) {
  const fileInputRef = useRef();
  const extensoes = Config?.endpoint?.extensoes
    .split(',')
    .map((ext) => `.${ext.trim()}`)
    .join(',');

  const handleChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const maxSize = Config?.endpoint?.tamanho * 1024 * 1024 || 0;

      const extensoesPermitidas =
        typeof Config?.endpoint?.extensoes === 'string'
          ? [
              ...Config.endpoint.extensoes
                .split(',')
                .map((ext) => ext.trim().toLowerCase()),
              'pdf',
            ]
          : ['pdf'];

      const extensaoArquivo = file.name.split('.').pop().toLowerCase();

      if (
        isValid(extensoesPermitidas) &&
        !extensoesPermitidas.includes(extensaoArquivo)
      ) {
        showToast('error', `Extensão .${extensaoArquivo} não permitida.`);
        e.target.value = null;
        return;
      }

      if (maxSize > 0 && file.size > maxSize) {
        showToast('error', 'Arquivo maior que o permitido.');
        e.target.value = null;
        return;
      }

      OnChange(file);
    }

    // Resetar valor do input para permitir seleção do mesmo arquivo
    e.target.value = null;
  };

  return (
    <div
      className={`anexos ${Editavel ? '' : 'disabled'}`}
      style={{
        order: Config?.posicao,
        borderColor: Config?.corborda,
        backgroundColor: Config?.corfundo,
      }}
    >
      <span
        className="anexoTitle"
        style={{ backgroundColor: Config?.corfundo, color: Config?.cortexto }}
      >
        {Config?.nome}
      </span>
      <div className="add" style={{ backgroundColor: Config?.corborda }}>
        <Add />
        Adicionar <br /> Anexo
        <input
          type="file"
          ref={fileInputRef}
          accept={extensoes}
          onChange={handleChange}
        />
      </div>

      {Array.isArray(DefaultData) &&
        DefaultData.filter((file) => file?.nomarq && file?.basarq)?.map(
          (file, index) => (
            <div key={index} className="item" style={{ color: Config }}>
              <button
                className="del"
                onClick={() => RemoveAnexo(file)}
                title="Remover Arquivo"
              >
                <End />
              </button>

              <button
                className="down"
                onClick={() => GetFile(file)}
                title="Fazer Download"
              >
                <Download />
              </button>

              <button
                className="view"
                title="Visualizar"
                style={{ backgroundColor: Config?.corborda }}
                onClick={() => {
                  newTab(file.nomarq, <RenderPdf data={file.basarq} />);
                }}
              >
                <View />
                <span className="filename">{file.nomarq}</span>
              </button>

              <ExtensionIcon extension={file.nomarq} />
              <span className="filename">{file.nomarq}</span>
            </div>
          )
        )}

      {Anexos?.map((file, index) => (
        <div key={index} className="item" style={{ color: Config }}>
          <button
            className="del"
            onClick={() => RemoveAnexo(file)}
            title="Remover Arquivo"
          >
            <End />
          </button>

          <button
            className="down"
            onClick={() => GetFile(file)}
            title="Fazer Download"
          >
            <Download />
          </button>

          <button
            className="view"
            title="Visualizar"
            style={{ backgroundColor: Config?.corborda }}
            onClick={() => {
              newTab(file.nomarq, <RenderPdf data={file.basarq} />);
            }}
          >
            <View />
            <span className="filename">{file.nomarq}</span>
          </button>

          <ExtensionIcon extension={file.name} />
          <span className="filename">{file.name}</span>
        </div>
      ))}

      {Files?.map((file, index) => (
        <div key={index} className="item" style={{ color: Config }}>
          <button
            className="del"
            onClick={(e) => {
              e.stopPropagation();
              RemoveFile(file);
            }}
            title="Excluir Arquivo"
          >
            <End />
          </button>

          <button
            className="down"
            onClick={() => GetFile(file)}
            title="Fazer Download"
          >
            <Download />
          </button>

          <button
            className="view"
            title="Visualizar"
            style={{ backgroundColor: Config?.corborda }}
            onClick={() => {
              newTab(file.nomarq, <RenderPdf data={file.basarq} />);
            }}
          >
            <View />
            <span className="filename">{file.nomarq}</span>
          </button>

          <ExtensionIcon extension={file} />
          <span className="filename">{file}</span>
        </div>
      ))}
    </div>
  );
}

Anexos.propTypes = {
  Editavel: PropTypes.bool,
  OnChange: PropTypes.func,
  Anexos: PropTypes.array,
  RemoveAnexo: PropTypes.func,
  RemoveFile: PropTypes.func,
  GetFile: PropTypes.func,
  Config: PropTypes.object,
  Files: PropTypes.array,
  DefaultData: PropTypes.array,
};
